export var INPUT_DEBOUNCE_DELAY = 500;
export var BACKEND_SEARCH_EMAIL_MIN_LENGTH = 2;
